import React, { useState } from 'react'
import { getNextAvatar } from '../../utils/avatars'
import { DiaperBankPublic } from '../../utils/DiaperBankDTO'
import { moneyFormatterRounded } from '../../utils/MoneyFormatter'
import pluralize from '../../utils/pluralize'
import Button from '../form/Button'

const COUNT_SHOWN = 3

const Subscriptions = ({ diaperBank }: { diaperBank: DiaperBankPublic }) => {
  const [showingAll, setShowingAll] = useState<boolean>(false)
  if (!diaperBank?.subscriptions) return null
  const numSubscriptions = diaperBank.subscriptions.length

  if (!numSubscriptions) return null

  return (
    <>
      <div className='horizontal-line' />
      <div className='my-6'>
        {!!numSubscriptions && (
          <div className='float-right font-thin text-sm'>
            {numSubscriptions} pledge{numSubscriptions > 1 ? 's' : ''}
          </div>
        )}
        <h3 className='text-lg leading-6 font-medium text-gray-900'>Recurring Contributors</h3>
        <div className='py-5 relative'>
          <ul className=''>
            {diaperBank.subscriptions.slice(0, showingAll ? diaperBank.subscriptions.length : COUNT_SHOWN).map((subscription, idx) => {
              const avatar = getNextAvatar()
              return (
                <li key={`contribution_${idx}`} className='shadow-sm'>
                  <div className='flex mb-2'>
                    <div className='w-12 table' style={{ backgroundColor: avatar.color }}>
                      <div className='text-center table-cell align-middle p-1' style={{ fontSize: '1.5em', height: '1.5em' }}>
                        <img src={avatar.image.src} alt={avatar.image.alt} />
                      </div>
                    </div>
                    <div className='px-4 py-1 flex-grow'>
                      <div className='text-sm mb-2'>{subscription.name}</div>
                      <div className='font-thin text-xs clear-both'>
                        <div className='float-left'>
                          {moneyFormatterRounded.format(subscription.amount)} per month for {subscription.numMonths} {pluralize(subscription.numMonths, 'more month')}
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              )
            })}
          </ul>
          {diaperBank.subscriptions.length > COUNT_SHOWN && (
            <Button outline onClick={() => setShowingAll(!showingAll)} fullWidth size='small'>
              {showingAll ? 'See Fewer Pledges' : 'See All Pledges'}
            </Button>
          )}
        </div>
      </div>
    </>
  )
}

export default Subscriptions
